import TuneIcon from '@/components/Icons/TuneIcon';
import { ArrowDropDown } from '@mui/icons-material';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const AddFilterButton = forwardRef(({ sx, onClick, describedBy, endAdornment, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant='contained'
      onClick={onClick}
      aria-describedby={describedBy}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        height: '37px',
        ...sx,
      }}
      {...props}
    >
      <TuneIcon />
      <span>Filter</span>
      {endAdornment}
    </Button>
  );
});

AddFilterButton.propTypes = {
  sx: PropTypes.object,
  onClick: PropTypes.func,
  describedBy: PropTypes.string,
  endAdornment: PropTypes.any,
};

AddFilterButton.defaultProps = {
  endAdornment: <ArrowDropDown sx={{ width: 16, height: 16 }} />,
};

export default AddFilterButton;
